<template>
  <div class="custom-date__box" :class="{'datetime__box':type==='datetime'}">
    <el-date-picker class="el-date__left" v-model="begin" :type="type" :value-format="format" :picker-options="beginPickerOptions" v-bind="$attrs"
      :placeholder="`${$attrs['start-placeholder'] || '开始日期'}`" @change="dateChange" @focus="beginFocusDate" default-time="00:00:00">
    </el-date-picker>
    {{$attrs['range-separator'] || '至'}}
    <el-date-picker class="el-date__right" v-model="end" :type="type" :value-format="format" :picker-options="endPickerOptions" :clearable="clearable"
      :placeholder="`${$attrs['end-placeholder'] || '结束日期'}`" @change="dateChange" @focus="endFocusDate" default-time="23:59:59" v-bind="$attrs">
    </el-date-picker>
  </div>
</template>

<script>
import { day } from '@/utils'
export default {
  name: 'yblDateRange',
  model: {
    prop: 'date',
    event: 'change'
  },
  props: {
    date: {
      type: Array | String,
      default: () => []
    },
    type: {
      type: String,
      default: () => 'date'
    },
    min: {
      type: Number,
      default: () => 0 // 最小日期值（当前日期递推）
    },
    max: {
      type: Number,
      default: () => 0 // 最大日期值（当前日期递推）
    },
    diff: { // 起始日期和截止日期 间隔范围 （单位：天） 默认值 负数 表示不计算
      type: Number,
      default: () => -1
    },
    unit: { // 日期范围单位 （ d 天 M 月 y 年）
      type: String,
      default: () => 'd'
    },
    beginPicker: {
      type: Object,
      default: () => null
    },
    endPicker: {
      type: Object,
      default: () => null
    },
    shortcuts: { // 快捷选项
      type: Boolean,
      default: () => true
    }
  },
  data () {
    return {
      begin: '',
      end: '',
      beginPickerOptions: {
        disabledDate (time) {
          return null
        },
        shortcuts: null
      },
      endPickerOptions: {
        disabledDate (time) {
          return null
        },
        shortcuts: null
      }
    }
  },
  created () {
    if (this.beginPicker) {
      this.beginPickerOptions = this.beginPicker
    } else {
      if (this.shortcuts) {
        this.beginPickerOptions.shortcuts = this.type === 'month' ? null : this.getShortcuts()
      }
    }
    if (this.endPicker) {
      this.endPickerOptions = this.endPicker
    } else {
      if (this.shortcuts) {
        this.endPickerOptions.shortcuts = this.type === 'month' ? null : this.getShortcuts()
      }
    }
    console.log(JSON.stringify(this.endPickerOptions))
    if (this.date && this.date.length) {
      let date = Array.isArray(this.date) ? this.date : this.date.split(',')
      this.begin = date[0]
      this.end = date[1]
    }
  },
  computed: {
    clearable () {
      const _clearable = this.$attrs['clearable']
      return _clearable === undefined ? true : _clearable
    },
    format () {
      return this.type === 'date' ? 'yyyy-MM-dd' : this.type === 'month' ? 'yyyy-MM' : 'yyyy-MM-dd HH:mm:ss'
    }
  },
  methods: {
    getDayDate (value, date, days = 1) { // date 为空时默认当前时间  value值表示多少天
      /* let dateTime = (date && new Date(date)) || new Date()
      return new Date(dateTime.setDate(dateTime.getDate() + value)) */
      let dateTime = day.now(date)
      if (this.type !== 'date' && dateTime.format('HH:mm:ss') !== '00:00:00') {
        dateTime = dateTime.add(-1, 'd')
      }
      const unit = this.unit
      /* if (unit === 'd') {
        return dateTime.add(value, unit).$d
      } */
      return dateTime.add(value, unit).add(days, 'd').$d
    },
    getDiffDate (value, date, days = -1) { // date 为空时默认当前时间  value值 匹配 unit 类型
      const dateTime = day.now(date)
      const unit = this.unit
      /* if (unit === 'd') {
        return dateTime.add(value, unit).$d
      } */
      return dateTime.add(value, unit).add(days, 'd').$d
    },
    beginFocusDate () {
      this.beginPickerOptions.disabledDate = (time) => {
        return this.min === 0 ? null : time.getTime() < this.getDayDate(this.min).getTime()
      }
      if (this.end) {
        this.beginPickerOptions.disabledDate = (time) => {
          if (this.diff >= 0) {
            return time.getTime() < this.getDayDate(-this.diff, this.end).getTime() || time.getTime() >= new Date(this.end).getTime()
          }
          return time.getTime() > new Date(this.end).getTime()// day.now(this.end)
        }
      }
      this.$emit('beginFocusDate')
    },
    endFocusDate () {
      this.endPickerOptions.disabledDate = (time) => {
        return this.max === 0 ? null : time.getTime() > this.getDayDate(this.max).getTime()
      }
      if (this.begin) {
        this.endPickerOptions.disabledDate = (time) => {
          if (this.diff >= 0) {
            return time.getTime() < this.getDayDate(0, this.begin, 0).getTime() || time.getTime() > this.getDiffDate(this.diff, this.begin).getTime()
          }
          return time.getTime() < this.getDayDate(0, this.begin).getTime()// new Date(this.begin).getTime()
        }
      }
      this.$emit('endFocusDate')
    },
    dateChange (val) {
      console.log('🚀 ~ file: DateRange.vue:188 ~ dateChange ~ action', val)
      val = (val && val.includes(',')) ? val.split(',') : val

      if (!this.begin) {
        this.begin = Array.isArray(val) ? val[0] : val
      }
      if (!this.end) {
        this.end = Array.isArray(val) ? val[1] : val
      }
      if (Array.isArray(val)) {
        this.begin = val[0]
        this.end = val[1]
      }
      const format = this.type === 'date' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss'
      let date = [day.format(this.begin, format), day.format(this.end, format)]
      if (!val) {
        this.begin = ''
        this.end = ''
        date = []
      }
      this.$emit('change', date)
    },
    getShortcuts () {
      const format = this.type === 'date' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss'
      const startFormat = this.type === 'date' ? 'YYYY-MM-DD' : 'YYYY-MM-DD 00:00:00'
      // const isDay = this.unit === 'd'
      const unit = this.unit
      const isMonth = this.unit === 'M'
      const isYear = this.unit === 'y'
      const diff = this.diff
      // const _day = isDay ? diff : ((isMonth && diff < 12) ? diff * 30 : 365)
      const _day = (isYear || diff === -1) ? 365 : diff
      const _dayText = isMonth ? '月' : '天'
      const shortcuts = [{
        text: '近3天',
        onClick (picker) {
          const end = day.nowF(format)
          const start = day.now().add(-2, 'd').format(startFormat)
          picker.$emit('pick', `${start},${end}`)
        }
      }, {
        text: '近7天',
        onClick (picker) {
          const end = day.nowF(format)
          const start = day.now().add(-6, 'd').format(startFormat)
          picker.$emit('pick', `${start},${end}`)
        }
      }, {
        text: '近30天',
        onClick (picker) {
          const end = day.nowF(format)
          const start = day.now().add(-29, 'd').format(startFormat)
          picker.$emit('pick', `${start},${end}`)
        }
      }, {
        text: `近${_day}${_dayText}`,
        onClick (picker) {
          const end = day.nowF(format)
          const diff = -(+_day - 1)
          const _unit = isYear ? 'd' : unit
          const start = day.now().add(diff, _unit).format(startFormat)
          picker.$emit('pick', `${start},${end}`)
        }
      }, {
        text: '今天',
        onClick (picker) {
          // const end = day.now().$d
          const start = day.nowF(startFormat)
          const end = day.nowF(format)
          picker.$emit('pick', `${start},${end}`)
        }
      }, {
        text: '本周',
        onClick (picker) {
          const end = day.now().format(format)
          const start = day.now().isoWeekday(1).format(startFormat)
          picker.$emit('pick', `${start},${end}`)
        }
      }, {
        text: '本月',
        onClick (picker) {
          const start = day.now().date(1).format(startFormat)
          const end = day.now().format(format)
          picker.$emit('pick', `${start},${end}`)
        }
      }, {
        text: '本年',
        onClick (picker) {
          const year = day.now().year()
          const end = day.now().format(format)
          const start = day.now(`${year}-01-01`).format(startFormat)
          picker.$emit('pick', `${start},${end}`)
        }
      }]
      if (isYear || diff === -1) {
        return shortcuts
      } else {
        let _shortcuts = shortcuts.filter((_, index) => index < 7)
        if (!isMonth) {
          if (diff <= 3) {
            _shortcuts = shortcuts.filter((_, index) => index === 3)
          } else if (diff <= 7) {
            _shortcuts = shortcuts.filter((_, index) => [0, 3].includes(index))
          } else if (diff <= 30) {
            _shortcuts = shortcuts.filter((_, index) => [0, 1, 3].includes(index))
          }
        }
        return _shortcuts
      }
    }
  },
  watch: {
    'date': function (newVal, oldVal) {
      if (this.date && this.date.length) {
        let date = Array.isArray(this.date) ? this.date : this.date.split(',')
        this.begin = date[0]
        this.end = date[1]
      } else {
        this.begin = ''
        this.end = ''
      }
    },
    'beginPicker': function (newVal, oldVal) {
      this.beginPickerOptions = newVal
    },
    'endPicker': function (newVal, oldVal) {
      this.endPickerOptions = newVal
    }
  }
}
</script>

<style lang="less" scoped>
.custom-date__box {
  width: 188px;
  // min-width: 193px;
  // max-width: 200px - 2px;
  border: 1px solid #dcdfe6;
  font-size: 12px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  overflow: hidden;
  .el-date-editor {
    width: 95px !important;
    min-width: 50px;
  }
  .el-input {
    min-width: auto !important;
    max-width: auto !important;
  }
  /deep/ .el-input--small {
    font-size: 12px;
  }
  /deep/ .el-input__inner {
    border: none; //
  }
  /deep/ .el-input--prefix .el-input__inner {
    padding-left: 25px;
  }
  /deep/ .el-input--suffix .el-input__inner {
    padding-right: 0; //15px;
  }
  /deep/ .el-input__prefix {
    left: 0;
  }
  /deep/ .el-input__suffix {
    right: -6px;
  }
  /deep/ .el-date__left {
    .el-input__suffix {
      display: none;
    }
  }
  /deep/ .el-date__right {
    // width: 90px;
    .el-input__prefix {
      display: none;
    }
    .el-input__inner {
      padding-left: 10px;
    }
    .el-input__suffix {
      right: 0;
    }
  }
  &.datetime__box {
    width: 300px;
    max-width: 300px;
    .el-date-editor {
      width: 150px !important;
      min-width: 150px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DateRange.vue